<template>
    <TransitionRoot as="template" :show="open">
        <Dialog as="div" class="relative z-10" @close="closeDialog()">
            <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </TransitionChild>

            <div class="fixed inset-0 z-10 overflow-y-auto">
                <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <DialogPanel class="relative transform overflow-hidden bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg lg:max-w-6xl sm:p-6">
                            <div class="sm:flex sm:items-start">
                                <div class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-gray-200 sm:mx-0 sm:h-10 sm:w-10">
                                    <img class="h-6 w-6" src="/img/polygon-matic-logo.svg" alt="" />
                                </div>
                                <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                    <DialogTitle as="h3" class="text-lg font-medium leading-6 text-gray-900">{{t('body:title')}}</DialogTitle>
                                    <div class="mt-2">
                                        <p class="text-sm text-gray-500">{{t('body:description')}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="lg:grid lg:grid-cols-12 lg:gap-x-5">
                                <div class="space-y-6 sm:px-6 lg:col-span-12 lg:px-0">
                                    <section aria-labelledby="billing-history-heading">
                                        <div class="bg-white pt-6 sm:overflow-hidden sm:rounded-md">
                                            <div class="mt-6 flex flex-col">
                                                <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                                    <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                                                        <div class="overflow-hidden border-t border-gray-200">
                                                            <table class="min-w-full divide-y divide-gray-200">
                                                                <thead class="bg-gray-50">
                                                                <tr>
                                                                    <th scope="col" class="px-6 py-3 text-left text-sm font-semibold text-gray-900">{{ t('body:txTableColDate') }}</th>
                                                                    <th scope="col" class="px-6 py-3 text-left text-sm font-semibold text-gray-900">{{ t('body:txTableColType') }}</th>
                                                                    <th scope="col" class="px-6 py-3 text-left text-sm font-semibold text-gray-900">{{ t('body:txTableColStatus') }}</th>
                                                                    <th scope="col" class="relative px-6 py-3 text-left text-sm font-medium text-gray-500">
                                                                        <span class="sr-only">{{ t('body:txTableColView') }}</span>
                                                                    </th>
                                                                </tr>
                                                                </thead>
                                                                <tbody class="divide-y divide-gray-200 bg-white">
                                                                <tr v-for="process in currentNft.processes" :key="process.id">
                                                                    <td class="whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-900">
                                                                        <time :datetime="process.datetime + ' ' + process.time">{{ process.date }} {{ process.time }}</time>
                                                                    </td>
                                                                    <td class="whitespace-nowrap px-6 py-4 text-sm text-gray-500">{{ process.type }}</td>
                                                                    <td class="whitespace-nowrap px-6 py-4 text-sm text-gray-500">{{ process.status }}</td>
                                                                    <td class="whitespace-nowrap px-6 py-4 text-right text-sm font-medium">
                                                                        <span v-for="link in process.links">
                                                                            <a :href="link" class="text-orange-600 hover:text-orange-900" target="_blank">{{ t('body:txTableView') }}</a><br />
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                            <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                <button type="button" class="mt-3 inline-flex w-full justify-center border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:w-auto sm:text-sm" @click="closeDialog()" ref="cancelButtonRef">
                                    {{t('body:cancel')}}
                                </button>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script setup>
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { ExclamationTriangleIcon } from '@heroicons/vue/24/outline'
import {ref} from "vue";
import translate from "../../../../lang";

const open = ref(false)
let currentNft = ref(null);

function show(nft) {
    currentNft.value = nft;
    open.value = true;
}
const emits = defineEmits(['close']);
function closeDialog() {
    open.value = false;
    emits('close');
}
const t = translate('dashboard.transactions');
defineExpose({ show });
</script>
